var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8.87604C10.2798 8.87604 8.87589 10.2799 8.87589 12.0003C8.87589 13.7206 10.2798 15.1245 12.0001 15.1245C13.7204 15.1245 15.1243 13.7206 15.1243 12.0003C15.1243 10.2799 13.7204 8.87604 12.0001 8.87604ZM21.3704 12.0003C21.3704 10.7065 21.3821 9.42448 21.3095 8.13307C21.2368 6.63307 20.8946 5.30182 19.7978 4.20495C18.6986 3.10573 17.3696 2.76588 15.8696 2.69323C14.5759 2.62057 13.2939 2.63229 12.0025 2.63229C10.7087 2.63229 9.42668 2.62057 8.13527 2.69323C6.63527 2.76588 5.30402 3.10807 4.20714 4.20495C3.10792 5.30416 2.76808 6.63307 2.69542 8.13307C2.62277 9.42682 2.63449 10.7089 2.63449 12.0003C2.63449 13.2917 2.62277 14.576 2.69542 15.8674C2.76808 17.3674 3.11027 18.6987 4.20714 19.7956C5.30636 20.8948 6.63527 21.2346 8.13527 21.3073C9.42902 21.3799 10.7111 21.3682 12.0025 21.3682C13.2962 21.3682 14.5782 21.3799 15.8696 21.3073C17.3696 21.2346 18.7009 20.8924 19.7978 19.7956C20.897 18.6964 21.2368 17.3674 21.3095 15.8674C21.3845 14.576 21.3704 13.294 21.3704 12.0003ZM12.0001 16.8073C9.33996 16.8073 7.19308 14.6604 7.19308 12.0003C7.19308 9.3401 9.33996 7.19323 12.0001 7.19323C14.6603 7.19323 16.8071 9.3401 16.8071 12.0003C16.8071 14.6604 14.6603 16.8073 12.0001 16.8073ZM17.004 8.11901C16.3829 8.11901 15.8814 7.61744 15.8814 6.99635C15.8814 6.37526 16.3829 5.8737 17.004 5.8737C17.6251 5.8737 18.1267 6.37526 18.1267 6.99635C18.1269 7.14383 18.0979 7.2899 18.0416 7.42619C17.9852 7.56248 17.9026 7.68632 17.7983 7.7906C17.694 7.89489 17.5702 7.97757 17.4339 8.03393C17.2976 8.09028 17.1515 8.11919 17.004 8.11901Z",
    fill: "url(#paint0_linear_328_2761)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_2761",
    x1: 21.8772,
    y1: 0.717126,
    x2: -1.84785,
    y2: 11.5881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.60877780c18426feb7d2fcb1a3b3a5c1.svg";
export { ForwardRef as ReactComponent };